export const environment = {
  production: true,
  apiURL: 'productionApi',
  state: 'production',
  serverLoggingUrl: 'https://kyrmannpay.com:9103/africapayment/angularlogger/add',
};
